import api from "@/lib/api";

export default {
  getAll(genericId) {
    return api.get("/api/v1/shared/checklist/get-all", { params: { any: genericId } });
  },
  create(checklist) {
    return api.post("/api/v1/shared/checklist/create", checklist);
  },
  updateAll(checklist) {
    return api.put("/api/v1/shared/checklist/update-all", { checklist });
  },
  remove(id) {
    const ids = Array.isArray(id) ? id.join(",") : id;
    return api.delete("/api/v1/shared/checklist/delete", { params: { ids } });
  },
};
